import { useAuthStore } from './store/auth'

const devCode = ['p', 'e', 'a', 'k', 'y']

let devCodePosition = 0

document.addEventListener('keydown', function (e) {
  const key = e.key
  const requiredKey = devCode[devCodePosition]

  if (key == requiredKey) {
    devCodePosition++
    if (devCodePosition == devCode.length) {
      activateCheats()
      devCodePosition = 0
    }
  } else {
    devCodePosition = 0
  }
})

function activateCheats() {
  const auth = useAuthStore()
  auth.setDevMode(true)
}
